/** Mirrors Android `ActivityFieldsEventBuilder`. */
export class ActivityFieldsEventBuilder {
    constructor() {
        this.fields = [];
    }
    put(schemaName, value) {
        if (!schemaName?.trim())
            return this;
        if (value === null || value === undefined)
            return this;
        if (typeof value === "string" && (!value.trim() || value === "null"))
            return this;
        if (typeof value === "number" && value === 0)
            return this;
        const scalar = typeof value === "boolean" ? (value ? "true" : "false") : value;
        this.fields.push({ SchemaName: schemaName, Value: scalar });
        return this;
    }
    build() {
        return this.fields;
    }
}
/** Mirrors Android `LeadDetailsBuilder` (scalar lead fields only). */
export class LeadDetailsBuilder {
    constructor() {
        this.leadDetails = [];
    }
    put(attribute, value) {
        if (!attribute?.trim())
            return this;
        if (value === null || value === undefined)
            return this;
        if (typeof value === "string" && (!value.trim() || value === "null"))
            return this;
        if (typeof value === "number" && value === 0)
            return this;
        const scalar = typeof value === "boolean" ? (value ? "true" : "false") : value;
        this.leadDetails.push({ Attribute: attribute, Value: scalar });
        return this;
    }
    putMxMobileDevice(attribute, subFields) {
        const name = attribute?.trim();
        if (!name || !subFields?.length)
            return this;
        const fields = subFields
            .filter((f) => f.Attribute?.trim())
            .map((f) => ({
            Attribute: f.Attribute.trim(),
            Value: f.Value ?? "",
        }));
        if (!fields.length)
            return this;
        this.leadDetails.push({
            Attribute: name,
            Value: "",
            Fields: fields,
        });
        return this;
    }
    build() {
        return this.leadDetails;
    }
}
